export default __webpack_public_path__ + "static/media/msme.90635a48.png";